import ContentPerformanceDetails from "./ContentPerformanceDetails";
export { ContentPerformanceDetails };
